import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';

import Fa from 'react-fontawesome';
import { Field, reduxForm, SubmissionError } from 'redux-form';
// Import Actions
import { requestCreateDemoOrganization } from '../../AdminActions';

class CreateDemoOrganizationButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.showForm,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
    if (props.showForm) {
      this.open();
    }
  }

  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  close() {
    if (this.mounted) {
      this.props.reset();
      this.setState({ showModal: false });
      this.props.onClose();
    }
  }

  open() {
    this.props.initialize(this.props.organization);
    this.setState({ showModal: true });
  }

  handleSubmit(data) {
    const { organization } = this.props;
    const params = {
      display_name: data.display_name,
    };
    return this.props.dispatch(requestCreateDemoOrganization(organization._id, params))
      .then(
        (demoOrganization) => {
          this.props.onAdd(demoOrganization);
          this.close();
        },
        (errors) => {
          throw new SubmissionError(errors.data || errors);
        },
      );
  }

  renderField({
    input, label, type, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl {...input} placeholder={label} type={type} disabled={submitting} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderModal() {
    const { handleSubmit, submitting, organization } = this.props;

    return (
      <Modal show={this.state.showModal} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Create Demo Organization</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Body>
            <FormGroup>
              <ControlLabel>Source</ControlLabel>
              <FormControl type="input" disabled readOnly value={organization.display_name} />
            </FormGroup>

            <Field name="display_name" type="text" component={this.renderField} label="New Name" />
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="link" disabled={submitting} onClick={this.close}>Cancel</Button>
            <Button bsStyle="primary" disabled={submitting} type="submit">
              {!submitting && <span><Fa name="clone" /> Create Demo Version</span>}
              {submitting && <span><Fa name="spinner" spin /> Creating</span>}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

  render() {
    const { disabled, size } = this.props;
    return (
      <span>
        {this.renderModal()}
        <Button disabled={disabled} bsSize={size} onClick={this.open} bsStyle="default">
          <Fa name="clone" /> Create Demo Org
        </Button>
      </span>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

CreateDemoOrganizationButton.propTypes = {
  initialize: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  size: PropTypes.string,
  onAdd: PropTypes.func,
  disabled: PropTypes.bool.isRequired,
  organization: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func,
  showForm: PropTypes.bool,
};
CreateDemoOrganizationButton.defaultProps = {
  onAdd: () => {},
  disabled: false,
  size: null,
  onClose: () => {},
  showForm: false,
};

const CreateDemoOrganizationForm = reduxForm({
  form: 'addDemoOrganization',
})(CreateDemoOrganizationButton);

export default connect(mapStateToProps)(CreateDemoOrganizationForm);
